<template>
	<div class="col">
		<div class="card mb-3">
			<div class="card-header d-flex justify-content-between align-items-center">
				{{ contact.name }} ({{ contact.relationship }})
				<div>
	                <a :href="'/contacts/'+contact.id+'/edit'" class="btn btn-sm btn-outline-secondary">Edit</a>
	                <button class="btn btn-sm btn-outline-danger ms-2" @click="deleteContact">Delete</button>
	            </div>
			</div>
	        <div class="card-body">
	            <div class="card-text">
	                <dl class="row">
	            		<dt class="col-sm-3">Mailing:</dt>
			            <dd class="col-sm-9" v-if="contact.no_mailing_address">
			            	(No mailing address)
			            </dd>
			            <dd class="col-sm-9" v-else>
			            	{{ getAttributeByType('formattedAddress', 'Mailing address') }}
			        	</dd>

			            <dt class="col-sm-3">Phone:</dt>
			            <dd class="col-sm-9">
				            {{ preferredPhone }}
			            </dd>

			            <dt class="col-sm-3">Email:</dt>
			            <dd class="col-sm-9">{{ getAttributeByType('address', 'Email') }}</dd>
	            	</dl>
	            </div>
	        </div>
	    </div>
	</div>
</template>

<script>
export default {
	name: "AlternateContactCard",
	props: {
		contact: Object
	},
	methods: {
		deleteContact() {
			this.$store.dispatch('contacts/deleteContact', this.contact)
		},
		getAttributeByType(attribute, type) {
			let formattedAttribute = attribute[0].toUpperCase()
			let channel = this.contact.channels.find(channel => channel.name == type)
			return channel !== undefined ? channel[attribute] : ''
		}
	},
	computed: {
		preferredPhone() {
			if (this.contact.preferred_phone == 'No Preferred Phone') {
				return 'No Preferred Phone'
			} else {
				let phoneType = this.contact.preferred_phone[0].toUpperCase()+this.contact.preferred_phone.slice(1).toLowerCase()+' phone'
				let phoneAddress = this.getAttributeByType('address', phoneType)
				return phoneAddress+' ('+this.contact.preferred_phone+')'
			}
		}
	}
}
</script>